//全局组件
import Vue from 'vue'

import mHeader from './mHeader';
Vue.component(mHeader.name, mHeader);
import mFooter from './mFooter';
Vue.component(mFooter.name, mFooter);